module.exports = __webpack_public_path__ + "static/winkry-logo-d7a23d2daa2c14d3a71a7a6b0ddf64f7.png";